import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Stack, Typography, useTheme } from '@mui/material';

type PropTypes = {
  close: () => void;
  open: boolean;
};

export const AdvancedStatsInfoDialog = ({ close, open }: PropTypes) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={close}
      maxWidth="sm"
      sx={{
        '& .paper': {
          borderStyle: 'solid',
          borderColor: theme.palette.ranked.main,
        },
      }}
    >
      <DialogTitle>
        <Typography variant="h4" textAlign={'center'} mb={2}>
          Advanced Stats Explained
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ width: '100%', height: '100%' }}>
        <Stack spacing={4}>
          <Typography>
            Averages are snapshotted every 50 questions per category
          </Typography>
          <Typography>
            Clicking a bar will display the historical averages per 50
            questions. The last bar will display the current average with the
            current question count.
          </Typography>
          <Typography>
            Compare how well you do in a category with the global averages in
            different MMR ranges!
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={close} fullWidth>
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
};
